/**
 * Gets the payload (second) part from a JWT in base64 format.
 *
 * Portal/web variant
 *
 * @param jwt A base64 string.
 */
export function parseJWTPayload(jwt: string): string {
  return atob(jwt.split('.')[1]);
}
